import { render } from "./DocumentClassAttributesForm.vue?vue&type=template&id=65d7ec7b&scoped=true&ts=true"
import script from "./DocumentClassAttributesForm.vue?vue&type=script&lang=ts"
export * from "./DocumentClassAttributesForm.vue?vue&type=script&lang=ts"

import "./DocumentClassAttributesForm.vue?vue&type=style&index=0&id=65d7ec7b&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d7ec7b"]])

export default __exports__